import { HttpClient } from '@wix/sdk-types';
import {
  SyncEditorDataOptions,
  syncEditorData as universalSyncEditorData,
} from './multilingual-genericconverter-v1-entity-mapper-entity-mapper.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/multilingual' };

export function syncEditorData(
  httpClient: HttpClient
): SyncEditorDataSignature {
  return (options?: SyncEditorDataOptions) =>
    universalSyncEditorData(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface SyncEditorDataSignature {
  /**
   * Update localization content with editor data
   */
  (options?: SyncEditorDataOptions): Promise<void>;
}

export {
  AccountInfo,
  ActionEvent,
  ChangedPages,
  CreateOrUpdateEditorMapperRequest,
  CreateOrUpdateEditorMapperResponse,
  CreateOrUpdateNileMapperRequest,
  CreateOrUpdateNileMapperResponse,
  DeleteEntityMapperRequest,
  DeleteEntityMapperResponse,
  DeleteMapperRequest,
  DeleteMapperResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  FieldType,
  GetEntityMapperRequest,
  GetEntityMapperResponse,
  GetMapperRequest,
  GetMapperResponse,
  GetSubscribedTopicsRequest,
  GetSubscribedTopicsResponse,
  HtmlNewRevisionSavedMessage,
  IdentificationData,
  IdentificationDataIdOneOf,
  ListEntityMapperRequest,
  ListEntityMapperResponse,
  ListMappersRequest,
  ListMappersResponse,
  Mapper,
  MapperField,
  MessageEnvelope,
  Page,
  PublishSiteTranslationsRequest,
  PublishSiteTranslationsResponse,
  RestoreInfo,
  RevisionInfo,
  SequencePath,
  SyncEditorDataOptions,
  SyncEditorDataRequest,
  SyncEditorDataResponse,
  SyncFilter,
  WebhookIdentityType,
} from './multilingual-genericconverter-v1-entity-mapper-entity-mapper.universal.js';
